import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, NotFoundPage, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import routes from '../../../routing/routes';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import ObalMaterialuNrSrBezchybnost from '../../../module/PracovnyKrok/PodpisPredseda/ObalMaterialuNrSrBezchybnost';
import {
  updateObalMaterialuNrSrBezchybnostClient,
} from '../../../client/external/evidencnaaplikacia/obalMaterialuNrSrBezchybnostClient';
import { usePodpisPredsedaFormDataContext } from '../../../context/PodpisPredsedaFormDataContext';
import { useLegislativnyMaterialDetail } from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import { useClient } from '../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrZaBezchybnostInitData,
} from '../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import SuccessMessages from '../../../module/SuccessMessages';

const ObalMaterialuNrSrBezchybnostEditPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const { obalMaterialuFormData } = usePodpisPredsedaFormDataContext();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.ODOSLAT_PREDSEDOVI_VLADY);
  const location = useLocation();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  const {
    wrapClient: fillSystemDataClient,
    status: fillSystemDataStatus,
    data: fillSystemData,
  } = useClient(fetchObalMaterialuNrSrZaBezchybnostInitData);

  const {
    wrapClient: updateObalMaterialuNrSrBezchybnost,
  } = useClient(updateObalMaterialuNrSrBezchybnostClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Odoslanie na podpis predsedovi vlády',
          to: routes.procesy.podpisPredseda.withParams(type, year, index, pracovnyKrokId),
        },
        {
          heading: 'Obal materiálu NR SR za bezchybnosť',
          to: location.pathname,
        }]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.hasPracovnyKrokInZasobnikPrace}
          hasOpravneniePracovneKroky={materialDetail?.hasOpravneniePracovneKroky}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && obalMaterialuFormData && (
              <>
                <PageHeadingWithBackButton
                  heading="Obal materiálu NR SR za bezchybnosť"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                  withBackLink
                />
                <Loader loading={fillSystemDataStatus.loading}>
                  <ObalMaterialuNrSrBezchybnost
                    material={materialDetail}
                    initFormData={fillSystemData || obalMaterialuFormData}
                    onSubmitForm={updateObalMaterialuNrSrBezchybnost}
                    fillSystemDataStatus={fillSystemDataStatus}
                    fillSystemData={fillSystemData}
                    fillSystemDataClient={fillSystemDataClient}
                  />
                </Loader>
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
      {(obalMaterialuFormData === null || obalMaterialuFormData === undefined) && (
        <NotFoundPage />
      )}
    </Layout>
  );
};

export default ObalMaterialuNrSrBezchybnostEditPage;
